import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { IonLoading, IonButton, IonList } from '@ionic/react';
import { InputField } from 'components/form';
import AppActions from 'redux/AppRedux';
import AuthActions, { AuthSelectors } from 'redux/AuthRedux';
import api_v2 from 'services/api_v2';
import schema from './schema';

const INITIAL_VALUES = {
  oldPassword: '',
  passwordConfirm: '',
  password: '',
};

function ChangePassword() {
  const dispatch = useDispatch();
  const token = useSelector(AuthSelectors.selectToken);

  const handleSubmit = async (payload, actions) => {
    try {
      const api = api_v2(token);
      
      await api.changePassword(
        payload.oldPassword,
        payload.password
      );

      dispatch(AuthActions.logout());
      dispatch(AppActions.setToast('Password changed successfully', 'success'));
    } catch (e) {
      dispatch(
        AppActions.setToast(
          e.message || 'There was problem changing password',
          'danger'
        )
      );
    }

    actions.setSubmitting(false);
  };

  return (
    <Formik
      initialValues={{ ...INITIAL_VALUES }}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ isSubmitting }) => {
        return (
          <Form>
            <IonLoading isOpen={isSubmitting} message="Loading..." />
            <IonList>
              <Field
                component={InputField}
                name="oldPassword"
                type="password"
                label="Old Password *"
              />
              <Field
                component={InputField}
                name="password"
                type="password"
                label="New Password *"
              />
              <Field
                component={InputField}
                name="passwordConfirm"
                type="password"
                label="Confirm Password *"
              />
              <div className="mb-2x mt-5x">
                <IonButton
                  color="secondary"
                  expand="block"
                  fill="solid"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Submit
                </IonButton>
              </div>
            </IonList>
          </Form>
        );
      }}
    </Formik>
  );
}

export default ChangePassword;
